import React, { useEffect, useState } from 'react';
import { Col } from 'reactstrap'
import { Row } from 'react-bootstrap';
import { dateFormat } from '../shared/util';

const GenericCertificateCoverage = ({ assetDetails, styles, cocTranslation }) => {

    const currencyFormat = (val) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val)

    return (
        <>
            <Row className="m-0 mt-4">
                <Col className="pl-0" lg="12" md="12">
                    <div className="mb-0">
                        <img
                            id="logo-image"
                            tabIndex={0}
                            width={cocTranslation?.headerContent?.COCLogoWidth_style}
                            src={assetDetails?.accountName ? `/document/GetCertificateLogo/${assetDetails?.accountName}` : cocTranslation?.headerContent?.COCLogoURL_style}
                        />
                    </div>
                </Col>
                <Col className="p-0">
                    <p className="mb-0 mt-3">650 Missouri Avenue</p>
                    <p className="mb-0">Jeffersonville, IN 47130</p>
                </Col>
            </Row>
            <Row className='d-block mt-4'>
                <h4 className='text-center'>{cocTranslation?.cocContent?.certificateTitle || 'ORDER CONFIRMATION'}</h4>
            </Row>
            <Row className={`m-0 mb-4 ${styles.addressContainer}`}>
                <Col className={`pl-0 ${styles.headerContainer} ${styles.addressDetail}`}>
                    <div className='mb-2'>
                        <span className={styles.userHeading}>{cocTranslation?.cocContent?.sellerHeading || 'Seller'}</span>
                    </div>
                    <div>{assetDetails?.dealerName}</div>
                    <div>{assetDetails?.dealerAddress1}</div>
                    {assetDetails?.dealerAddress2 && <div> {assetDetails?.dealerAddress2}</div>}
                    <div>{`${assetDetails?.dealerCity}, ${assetDetails?.dealerStateAbbreviation} ${assetDetails.dealerZip}`} </div>
                </Col>
                <Col className={styles.addressDetail}>
                    <div className='mb-2'>
                        <span className={styles.userHeading}>{cocTranslation?.cocContent?.issuedHeading || 'Issued To'}</span>
                    </div>
                    <div>{assetDetails?.customerName}</div>
                    <div>{assetDetails?.customerAddress1}</div>
                    {assetDetails?.customerAddress2 && <div> {assetDetails?.customerAddress2}</div>}
                    <div>{`${assetDetails?.customerCity}, ${assetDetails?.customerStateAbbreviation} ${assetDetails.customerZip}`} </div>
                </Col>
            </Row>
            <Row>
                <Col className="md-12 lg-12 mb-4">
                    <div className={styles.introWrapper}>
                        {cocTranslation?.cocContent?.introParagraph || `This Plan provides protection for the Covered Products. The enclosed terms and conditions
                            provide details regarding coverage.`}
                    </div>
                    {cocTranslation?.cocContent?.introParagraphSecondary &&
                        <div className="mt-3">
                            {cocTranslation?.cocContent?.introParagraphSecondary}
                        </div>
                    }
                </Col>                                
            </Row>
            <Row className="mb-4">
                <Col className="md-12 lg-12">                                         
                    <div className={styles.planInformation}>
                        <h6>PLAN INFORMATION</h6>
                        {cocTranslation?.cocContent?.planNum && <p><span>{cocTranslation?.cocContent?.planNum}</span> {assetDetails?.clientContractNumber}</p>}
                        {cocTranslation?.cocContent?.retailPrice && <p><span>{cocTranslation?.cocContent?.retailPrice}</span> {currencyFormat(assetDetails?.planTotal)}</p>}
                        {cocTranslation?.cocContent?.renewalFee && <p><span>{cocTranslation?.cocContent?.renewalFee}</span> {currencyFormat(assetDetails?.renewalAmt)}</p>}
                        {cocTranslation?.cocContent?.serviceFee &&
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.serviceFee}</span>
                                {(assetDetails?.serviceFee === null || assetDetails?.serviceFee === 0) ? 'Not Applicable' : currencyFormat(assetDetails?.serviceFee)}
                            </p>
                        }
                        {cocTranslation?.cocContent?.planBundle && <p><span>{cocTranslation?.cocContent?.planBundle}</span> {assetDetails?.planName}</p>}
                        {cocTranslation?.cocContent?.coveredProducts && <p><span>{cocTranslation?.cocContent?.coveredProducts}</span></p>}
                        {assetDetails?.assetDetails?.length && 
                            <ul>
                                {assetDetails?.assetDetails?.map(asset => {
                                    return <li>
                                        {asset.brandName.toLowerCase() !== "unknown" && asset.brandName} {asset.assetName} {asset.modelNumber && <span>Model: {asset.modelNumber}</span>} {asset.serialNumber && <span>Serial: {asset.serialNumber}</span>}
                                        </li>
                                })}
                            </ul>
                        }
                    </div>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col className="md-12 lg-12">                                      
                    <div className={styles.planInformation}>
                        <h6>PLAN TERM:</h6>
                        {cocTranslation?.cocContent?.purchaseDate && 
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.purchaseDate}</span>
                                {assetDetails?.purchaseDate === null ? 'Not Available' : dateFormat(assetDetails?.purchaseDate, assetDetails?.customerCountryId)}
                            </p>
                        }
                        {cocTranslation?.cocContent?.term && <p><span>{cocTranslation?.cocContent?.term}</span> {assetDetails?.term}</p>}
                        {cocTranslation?.cocContent?.waitPeriod && <p><span>{cocTranslation?.cocContent?.waitPeriod}</span> {assetDetails?.waitPeriod} {'days'}</p>}
                        {cocTranslation?.cocContent?.termRenewal && <p><span>{cocTranslation?.cocContent?.termRenewal}</span> {assetDetails?.renewalTerm}</p>}
                        {cocTranslation?.cocContent?.effectiveDate && 
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.effectiveDate}</span> 
                                {assetDetails?.coverageStart === null ? 'Not Available' : dateFormat(assetDetails?.coverageStart, assetDetails?.customerCountryId)}
                            </p>
                        }
                        {cocTranslation?.cocContent?.expDate &&
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.expDate}</span>
                                {assetDetails?.coverageEnd === null ? 'Not Available' : dateFormat(assetDetails?.coverageEnd, assetDetails?.customerCountryId)}
                            </p>}
                    </div>
                </Col>
            </Row>
            {(cocTranslation?.cocContent?.coverageType1 || 
                cocTranslation?.cocContent?.coverageType2 || 
                cocTranslation?.cocContent?.coverageType3 || 
                cocTranslation?.cocContent?.coverageType4 ||
                cocTranslation?.cocContent?.coverageType5
            ) &&
                <Row className="mb-4">
                    <Col className="md-12 lg-12">                                      
                        <div className={styles.planInformation}>
                            <h6>{cocTranslation?.cocContent?.typeOfCoverage || 'COVERED BREAKDOWNS:'}</h6>
                            <p><span>{cocTranslation?.cocContent?.coverageType1}</span> {assetDetails?.coverage1}</p>
                            <p><span>{cocTranslation?.cocContent?.coverageType2}</span> {assetDetails?.coverage2}</p>
                            <p><span>{cocTranslation?.cocContent?.coverageType3}</span> {assetDetails?.coverage3}</p>
                            <p><span>{cocTranslation?.cocContent?.coverageType4}</span> {assetDetails?.coverage4}</p>
                            <p><span>{cocTranslation?.cocContent?.coverageType5}</span> {assetDetails?.coverage4}</p>
                        </div>
                    </Col>
                </Row>
            }
            {(cocTranslation?.cocContent?.technicalCoverage1 ||
                cocTranslation?.cocContent?.technicalCoverage2 ||
                cocTranslation?.cocContent?.technicalCoverage3 ||
                cocTranslation?.cocContent?.technicalCoverage4
            ) &&
                <Row>
                    <Col className="md-12 lg-12">                                      
                        <div className={styles.planInformation}>
                            <h6>{cocTranslation?.cocContent?.techincalCoverage || 'Technical Coverages:'}</h6>
                            <p><span>{cocTranslation?.cocContent?.technicalCoverage1}</span> {assetDetails?.technicalSupportCoverage1}</p>
                            <p><span>{cocTranslation?.cocContent?.technicalCoverage2}</span> {assetDetails?.technicalSupportCoverage2}</p>
                            <p><span>{cocTranslation?.cocContent?.technicalCoverage3}</span> {assetDetails?.technicalSupportCoverage3}</p>
                            <p><span>{cocTranslation?.cocContent?.technicalCoverage4}</span> {assetDetails?.technicalSupportCoverage4}</p>
                        </div>
                    </Col>
                </Row>
            }
            {cocTranslation?.cocContent?.noteParagraph &&
                <Row className='m-0 mt-3 '>
                    <p className='mb-0'>{cocTranslation?.cocContent?.noteParagraph}</p>
                </Row>
            }
            {cocTranslation?.cocContent?.obligorParagraph &&
                <Row className='m-0 mt-3 '>
                    <p className='mb-0'>{cocTranslation?.cocContent?.obligorParagraph}</p>
                </Row>
            }
            {cocTranslation?.cocContent?.adminParagraph &&
                <Row className='m-0 mt-3'>
                    <p className='mb-0'>{cocTranslation?.cocContent?.adminParagraph}</p>
                </Row>
            }
            <Row className='m-0 mt-3'>
                <div className={styles.footerText}>
                    {cocTranslation?.cocContent?.forService}
                </div>
                <div className={styles.footerText}>
                    {cocTranslation?.cocContent?.serviceContact}
                </div>
            </Row>
        </>
    )
}

export default GenericCertificateCoverage;